module.exports = __webpack_public_path__ + "img/masvalor.df57ed95.svg";